__turbopack_context__.v({
  "colorInfoContainer": "NkvWoW_colorInfoContainer",
  "colorLabel": "NkvWoW_colorLabel",
  "colorOption": "NkvWoW_colorOption",
  "colorOptionsContainer": "NkvWoW_colorOptionsContainer",
  "colorPickerComponent": "NkvWoW_colorPickerComponent",
  "colorPickerComponentContainer": "NkvWoW_colorPickerComponentContainer",
  "colorPickerContainer": "NkvWoW_colorPickerContainer",
  "colorPreviewContainer": "NkvWoW_colorPreviewContainer",
  "colorPreviewTile": "NkvWoW_colorPreviewTile",
  "hexInput": "NkvWoW_hexInput",
  "rgbInput": "NkvWoW_rgbInput",
  "rgbShift": "NkvWoW_rgbShift",
  "rgbTile": "NkvWoW_rgbTile",
  "rgbTileCycle": "NkvWoW_rgbTileCycle",
  "selectedColor": "NkvWoW_selectedColor",
});
